import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { TitleComponent } from './shared/components/title/title.component';
import { BreadcrumbsComponent } from './shared/components/breadcrumbs/breadcrumbs.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { ComingSoonComponent } from './shared/components/coming-soon/coming-soon.component';
import { CurrencyPipe } from '@angular/common';
import { AppInitService } from './shared/services/app-init.service';
import { UnauthLayoutComponent } from './layouts/unauth-layout/unauth-layout.component';
import { MenuBreadcrumbsComponent } from './shared/components/menu-breadcrumbs/menu-breadcrumbs.component';
import { BellNotifyUserComponent } from './shared/components/bell-notify-user/bell-notify-user.component';
import { NotificationsService } from './core/services/profile/notifications.service';
import { AdminNotificationsService } from './core/services/admin/admin-notifications.service';
import { GenerationJobsService } from './modules/accounting/automatic-data-generation/generation-jobs.service';
import { ReceptionAdvancedComponent } from './modules/reception-advanced/reception-advanced.component';
import { ReceptionAdvancedDoeqComponent } from './modules/reception-advanced-doeq/reception-advanced-doeq.component';
import { AuthService } from './core/services/auth/auth.service';
import { MenuService } from './shared/services/menu.service';



export function init_app(appLoadService: AppInitService) {
  return () => appLoadService.init();
}
@NgModule({
  declarations: [
    AppComponent,
    TitleComponent,
    BreadcrumbsComponent,
    ContentLayoutComponent,
    AuthLayoutComponent,
    DashboardLayoutComponent,
    NotFoundComponent,
    ComingSoonComponent,
    UnauthLayoutComponent,
    MenuBreadcrumbsComponent,
    BellNotifyUserComponent,
    ReceptionAdvancedComponent,
    ReceptionAdvancedDoeqComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    CoreModule,
    SharedModule
  ],
  providers: [
    CurrencyPipe,
    AppInitService,
    NotificationsService,
    AdminNotificationsService,
    GenerationJobsService,
    AuthService,
    MenuService,
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [AppInitService],
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts